import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import Select from './select';
import useAsync from './use-async';
import useCreatable from './use-creatable';
import useStateManager from './use-state-manager';
var AsyncCreatableSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var stateManagerProps = useAsync(props);
  var creatableProps = useStateManager(stateManagerProps);
  var selectProps = useCreatable(creatableProps);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, selectProps));
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default AsyncCreatableSelect;